import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';

import { useReturnConfig } from '../../../return-config-provider';

import { messages } from './messages';
import style from './styles.module.less';

type FooterProps = {
  onClose: () => void;
};

export const Footer = ({ onClose }: FooterProps) => {
  const { isValid, updateShipFrom } = useReturnConfig();

  const onSave = useCallback(() => {
    updateShipFrom();
    onClose();
  }, [onClose, updateShipFrom]);

  return (
    <ModalFooter className={style['edit-address-footer']}>
      <FlexRow className={style['edit-address-footer-buttons']} gap={Gap.Space8}>
        <ModalFooterCancelButton />
        <Button disabled={!isValid} onClick={onSave} theme='primary'>
          <FormattedMessage {...messages.saveButton} />
        </Button>
      </FlexRow>
    </ModalFooter>
  );
};
